export enum RequirementPlotType {
  CAPABILITY_CURVE = 'capability_curve',
  REQUIREMENT = 'requirement',
  BATTERY_CHARGE = 'battery_charge',
  EXTRA = 'extra',
  PRE_SOLVE = 'pre_solve',
}
